<script setup lang="ts">
import {QuestionFieldsPresenter} from "@/utils/presenters/QuestionFieldsPresenter.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import FieldType from "@/utils/constants/FieldType.ts";
import {onBeforeMount} from "vue";
import PageTitle from "@/components/settings/PageTitle.vue";
import QuestionFieldsEditor from "@/components/questionFields/QuestionFieldsEditor.vue";
import Translator from "@/utils/common/Translator.ts";
import NamaURLS from "@/utils/constants/NamaURLS.ts";
import {useMessagesStore} from "@/stores/ToastDataStore.ts";
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import LoginUtils from "@/utils/login/LoginUtils.ts";
import QuestionField = namaTypes.QuestionField;

const {compactMode} = storeToRefs(useNamaFlagsStore());

let presenter: QuestionFieldsPresenter = new QuestionFieldsPresenter();
let questionFields: QuestionField[] = [];
let defaultValues = []
questionFields.push(NamaCommon.createQuestionField("currentPassword", FieldType.Password));
questionFields.push(NamaCommon.createQuestionField("password", FieldType.Password));
questionFields.push(NamaCommon.createQuestionField("confirmNewPassword", FieldType.Password));

onBeforeMount(async () => {
  await presenter.edit(questionFields, defaultValues);
})

async function onSaveClick() {
  let changePasswordInfo: Record<string, any> = {
    userIdToChangePasswordFor: LoginUtils.currentUserId(),
    newPassword: presenter.fetchRecord().password,
    confirmPassword: presenter.fetchRecord().confirmNewPassword,
    passwordMustBeChanged: false
  };
  let response = await NamaCommon.namaFetch(NamaURLS.Change_Password, {data: changePasswordInfo});
  if (response && response.result && response.result.succeded) {
    useMessagesStore().showSuccessMessage();
    // todo:: logout
    await LoginUtils.logout();
  }
}
</script>

<template>
  <div>
    <PageTitle title="resetPassword" icon="lock"/>
    <div class="tw-w-full tw-justify-items-center">
      <q-card-section
        class="tw-w-[70%] tw-shrink tw-text-primary-light dark:tw-text-primary-dark tw-text-base tw-font-normal tw-h-fit tw-flex-nowrap tw-overflow-y-auto !tw-max-h-[90%]">
        <QuestionFieldsEditor :presenter="presenter" :singleColumnGroup="true" :doNotApplyThemeLayouts="true"/>
      </q-card-section>
      <q-card-section :dir="Translator.fetchDir()" class="tw-flex-none">
        <div class="tw-flex tw-flex-row tw-gap-4 tw-justify-center ">
          <q-btn
            :label="Translator.translateId('save')"
            @click="onSaveClick()"
            :dense="compactMode"
            class="tw-bg-primary-light dark:tw-bg-primary-dark tw-text-white tw-text-base tw-font-normal tw-rounded-md tw-min-w-28 tw-max-w-fit"/>
        </div>
      </q-card-section>
    </div>
  </div>
</template>

<style scoped>

</style>
